import PropTypes from 'prop-types';

const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);

export default refType;
